import { Injectable } from '@angular/core';
import {BaseService} from "@ui-kit/framework/common/base.service";
import {environment} from "@env/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Industry, IndustryCategory, SelectableCategory} from "./industry.model";

@Injectable({
  providedIn: 'root'
})
export class ManageIndustriesService extends BaseService{

  baseUrl: string = `${environment.apiSharedServicesHost}/console/types/industry`;
  private readonly offeringUrl = `${this.baseUrl}/offering`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Get all enabled industries for the current offering
   */
  getAllEnabledIndustries(): Observable<IndustryCategory[]> {
    return this.http.get<IndustryCategory[]>(this.offeringUrl);
  }

  /**
   * Get all selectable options for offering configuration (including disabled industries)
   */
  getAllSelectableOptionsForOffering(): Observable<SelectableCategory[]> {
    return this.http.get<SelectableCategory[]>(`${this.offeringUrl}/config`);
  }

  /**
   * Save offering industry configuration
   */
  saveOfferingConfig(selectedCategories: SelectableCategory[]): Observable<SelectableCategory[]> {
    return this.http.post<SelectableCategory[]>(`${this.offeringUrl}/config`, selectedCategories);
  }

  // Methods from ManageIndustryTypesController

  /**
   * Save a master category (requires internal admin permissions)
   */
  saveMasterCategory(category: IndustryCategory): Observable<IndustryCategory> {
    return this.http.post<IndustryCategory>(`${this.baseUrl}/master/category`, category);
  }

  /**
   * Save an offering-specific category
   */
  saveOfferingCategory(category: IndustryCategory): Observable<IndustryCategory> {
    return this.http.post<IndustryCategory>(`${this.baseUrl}/offering/category`, category);
  }

  /**
   * Save a master industry under a specific category (requires internal admin permissions)
   */
  saveMasterIndustry(industry: Industry, categoryId: number): Observable<Industry> {
    return this.http.post<Industry>(`${this.baseUrl}/master/category/${categoryId}/industry`, industry);
  }

  /**
   * Save an offering-specific industry under a specific category
   */
  saveOfferingIndustry(industry: Industry, categoryId: number): Observable<Industry> {
    return this.http.post<Industry>(`${this.baseUrl}/offering/category/${categoryId}/industry`, industry);
  }
}
